module.exports = __webpack_public_path__ + "static/media/logo.fcd0c252.svg";